<template>
  <div class="schedule-wrapper">
    <div class="schedule-heading cmf-tablerow">
      <div><b>How to join an event</b></div>
      <div>
        When an event begins, check out the video player at the top of this page
        for instructions on how to join.
      </div>
    </div>
    <div v-if="keys(splitSchedules).length">
      <Schedule :value="splitSchedules" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "SchedulePage",
  metaInfo: {
    titleTemplate: "%s - Schedule"
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.fetchResource("Schedule");
    },
    splitSchedule(collection) {
      return _.groupBy(collection || [], schedule => {
        if (schedule.start_at) {
          return this.$moment(schedule.start_at).format("dddd, MMMM D");
        } else {
          return "TBD";
        }
      });
    },
    keys(obj) {
      return Object.keys(obj);
    }
  },
  computed: {
    ...mapState({
      schedules: state => state.page.cache[state.page.active?.id]?.Schedule
    }),
    splitSchedules() {
      return this.splitSchedule(this.schedules?.all);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.schedule-heading {
  font-size: 20px;
  line-height: 1.3;
  color: $cmf-darkgrey;
}

.h2 {
  font-weight: 500;
  color: $primary;
  text-align: left;
}

.h1 {
  margin: 70px 0;
  color: $primary;
  font-weight: 900;
  text-align: left;
}

.edt-time {
  font-size: 18px;
  color: #676767;
  margin-bottom: 2.5em;
}

@media screen and (max-width: 960px) {
  .schedule-heading {
    font-size: 18px;
    > div:first-child {
      margin-bottom: 10px;
    }
  }
}
</style>
